import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

export const createQuoteItem = async (
  organization_id: string | number,
  quote_id: string | number,
  item_name: string,
  quantity: number,
  unit_price: number
) => {
  try {
    const token = await getAuthToken();
    if (!token) {
      return { success: false, data: "error: Token does not exist" };
    }

    const headers = { Authorization: `Bearer ${token.data}` };

    const body = {
      item_name,
      quantity,
      unit_price,
    };

    const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/items/`;
    const response = await axios.post(endpoint, body, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      console.error("Quote item creation failed:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const fetchQuoteItems = async (
  organization_id: string | number,
  quote_id: string | number
) => {
  try {
    const token = await getAuthToken();
    if (!token) {
      return { success: false, data: "error: Token does not exist" };
    }

    const headers = { Authorization: `Bearer ${token.data}` };

    const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/items/`;
    const response = await axios.get(endpoint, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      console.error("Fetching quote items failed:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const updateQuoteItem = async (
  organization_id: string | number,
  quote_id: string | number,
  item_id: string | number,
  updates: {
    item_name?: string;
    quantity?: number;
    unit_price?: number;
  }
) => {
  try {
    const token = await getAuthToken();
    if (!token) {
      return { success: false, data: "error: Token does not exist" };
    }

    const headers = { Authorization: `Bearer ${token.data}` };

    const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/items/${item_id}/`;
    const response = await axios.patch(endpoint, updates, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      console.error("Updating quote item failed:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const deleteQuoteItem = async (
  organization_id: string | number,
  quote_id: string | number,
  item_id: string | number
) => {
  try {
    const token = await getAuthToken();
    if (!token) {
      return { success: false, data: "error: Token does not exist" };
    }
    const headers = { Authorization: `Bearer ${token.data}` };
    const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/items/${item_id}/`;
    const response = await axios.delete(endpoint, { headers });
    console.log('delete response', response);
    if (response.status === 204) {
      return { success: true, data: "Quote item deleted successfully" };
    } else {
      console.error("Deleting quote item failed:", response.data);
      return { success: false, data: response.data||"Failed to delete quote item" };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};
